import stakeCardsImage from "../../Assets/Images/su-stake-cards.png";

export default function CardPair() {
  return (
    <div className="su-illustration su-illustration--cards" aria-hidden="true">
      <img src={stakeCardsImage} alt="" />
    </div>
  );
}
